import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useId, useRef } from 'react';
import { Button } from './Button.js';
import { StatusIcon } from './StatusIcon.js';
export function Dialog({ open, kind, title, description, children, confirmLabel, cancelLabel, onConfirm, onCancel, busy = false, confirmDisabled = false, }) {
    // Id unik per instans: dua dialog yang pernah terpasang bersamaan membuat
    // `aria-labelledby` menunjuk simpul yang salah (telaah kode).
    const ids = useId();
    const titleId = `assist-dialog-title-${ids}`;
    const descId = `assist-dialog-desc-${ids}`;
    const panelRef = useRef(null);
    const confirmRef = useRef(null);
    useEffect(() => {
        if (!open)
            return undefined;
        // Fokus masuk ke dialog. Untuk dialog merusak, fokus TIDAK diletakkan pada
        // tombol merah: menekan Enter karena kebiasaan tidak boleh menghancurkan apa pun.
        const target = kind === 'destructive' ? panelRef.current : confirmRef.current;
        target?.focus();
        function onKeyDown(event) {
            if (event.key === 'Escape') {
                event.preventDefault();
                onCancel();
                return;
            }
            if (event.key !== 'Tab' || !panelRef.current)
                return;
            const focusable = panelRef.current.querySelectorAll('button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            if (focusable.length === 0)
                return;
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            }
            else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        }
        document.addEventListener('keydown', onKeyDown);
        return () => document.removeEventListener('keydown', onKeyDown);
    }, [open, kind, onCancel]);
    if (!open)
        return null;
    const iconKind = kind === 'destructive' ? 'danger' : kind === 'confirm' ? 'warning' : 'information';
    return (_jsx("div", { className: "assist-dialog__backdrop", onMouseDown: onCancel, children: _jsxs("div", { ref: panelRef, tabIndex: -1, className: `assist-dialog assist-dialog--${kind}`, 
            // INI baris yang penting: merusak → alertdialog.
            role: kind === 'destructive' ? 'alertdialog' : 'dialog', "aria-modal": "true", "aria-labelledby": titleId, "aria-describedby": descId, onMouseDown: (e) => e.stopPropagation(), children: [_jsxs("div", { className: "assist-dialog__head", children: [_jsx(StatusIcon, { kind: iconKind, size: 22 }), _jsx("h2", { id: titleId, className: "assist-dialog__title", children: title })] }), _jsx("p", { id: descId, className: "assist-dialog__desc", children: description }), children ? _jsx("div", { className: "assist-dialog__body", children: children }) : null, _jsxs("div", { className: "assist-dialog__actions", children: [_jsx(Button, { variant: "secondary", onClick: onCancel, disabled: busy, children: cancelLabel }), _jsx(Button, { ref: confirmRef, variant: kind === 'destructive' ? 'destructive' : 'primary', onClick: onConfirm, busy: busy, disabled: confirmDisabled, children: confirmLabel })] })] }) }));
}
//# sourceMappingURL=Dialog.js.map